import React from 'react';
import TwoColumnRow from '../../../../tc-ui/two-column-row.jsx';
import TravelSalesDatesPickers from '../../../generic-components/special-offer-tables/travel-sales-dates-pickers';
import R from 'ramda';
export default ({ data, contractingPeriod, onTextFieldChangeWithKeyPath, disableSalesDates }) => {
  return (
    <div>
      <TwoColumnRow
        outerContainerStyle={{ height: `${data.validDatesOfSale.length * 48}px`, overflow: '' }}
        leftColumnStyle={{ position: 'relative', top: '8px', fontSize: '16px', width: '45%' }}
        leftColumnContent={
          <div>
            Please enter the dates that agents can sell this offer.
            <span style={{ fontSize: '12px', color: '#ff4081' }}>* Required</span>
          </div>
        }
        rightColumnStyle={{ width: '48%' }}
        rightColumnContent={
          <div style={{ width: '100%', position: 'relative', top: '-10px' }}>
            <TravelSalesDatesPickers
              forSaleDates
              disabled={disableSalesDates}
              contractingPeriod={contractingPeriod}
              dates={data.validDatesOfSale}
              onChange={(keyPath, value) =>
                onTextFieldChangeWithKeyPath({
                  keyPath: R.concat(['data', 'validDatesOfSale'], keyPath),
                  value,
                })
              }
            />
          </div>
        }
      />
      <TwoColumnRow
        outerContainerStyle={{ height: `${data.validDatesOfTravel.length * 48}px`, overflow: '' }}
        leftColumnStyle={{ position: 'relative', top: '8px', fontSize: '16px', width: '45%' }}
        leftColumnContent={
          <div>
            Please enter the dates of travel when this offer can be used.
            <span style={{ fontSize: '12px', color: '#ff4081' }}>* Required</span>
          </div>
        }
        rightColumnStyle={{ width: '48%' }}
        rightColumnContent={
          <div style={{ width: '100%', position: 'relative', top: '-10px' }}>
            <TravelSalesDatesPickers
              contractingPeriod={contractingPeriod}
              dates={data.validDatesOfTravel}
              onChange={(keyPath, value) =>
                onTextFieldChangeWithKeyPath({
                  keyPath: R.concat(['data', 'validDatesOfTravel'], keyPath),
                  value,
                })
              }
            />
          </div>
        }
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/special-offers/dates.jsx